import { PAGE_REFRESH } from '../keys'
const initialState = { refreshing: false }
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case PAGE_REFRESH: {
            return { ...state, refreshing: action.payload }
        }
        default:
            return { ...state }
    }

} 